<template>
  <div class="element-board">
    <slot />
  </div>
</template>
<script>
export default {
}
</script>
